import React, { useState, useEffect } from "react";
import {
  ApiUrl,
  ApiKey,
  SessionKey,
  AlertTypes,
  WebUrl,
  PhoneNumberPrefix,
  KEY
} from "./../../util/Constant.js";
import ApiEngine from "./../../util/ApiEngine.js";
import { useForm } from "react-hook-form";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { createFormBody, stringIsNullOrEmpty } from "./../../util/Util.js";
import { performLogin, performLogout, performRegisterLogin, createGamePointsBonusRecord } from "../../redux/AuthAction.js";
import Background_1 from "../../assets/img/home/register_background.png";

const Register = (props) => {
  const { t } = useTranslation();
  const _history = useHistory();
  const _dispatch = useDispatch();
  const [referralCode, setReferralCode] = useState("");

  var { isLoggedIn } = useSelector((state) => state.authState);

  useEffect(() => {
    {
      const search = window.location.search;
      const params = new URLSearchParams(search);
      const tempReceivedRreferralCode = params.get("code");
      let receivedRreferralCode = tempReceivedRreferralCode.trim();
      if (!stringIsNullOrEmpty(receivedRreferralCode)) {
        setReferralCode(receivedRreferralCode);
      } else {
        _history.replace(WebUrl._URL_MAIN);
          }
    }
        
    if (isLoggedIn) {
      _dispatch(performLogout());
    }

    return () => {
      window.removeEventListener("scroll", (e) => {
      });
    };
}, [(localStorage.getItem(SessionKey._LANGUAGE) && localStorage.getItem(SessionKey._LANGUAGE) != 'undefined' ?
localStorage.getItem(SessionKey._LANGUAGE) : 'en')]);

  return (
    <div id="register" style={{ backgroundImage: `url(${Background_1})` }}>
     
    </div>
  );
};

export default Register;
